import { render, staticRenderFns } from "./BlackListGenerals.vue?vue&type=template&id=7131981f&"
import script from "./BlackListGenerals.vue?vue&type=script&lang=ts&"
export * from "./BlackListGenerals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports